import React from "react";
import "./ProfileButton.scss";
import { ChevronDown } from "../../../src/SVG/ChevronDown";

interface ProfileButtonProps {
  name: string;
  initials: string;
  onClick?: () => void;
  className?: string;
  imageUrl?: string;
  avatarBackgroundColor?: string;
}

export const ProfileButton: React.FC<ProfileButtonProps> = ({
  name,
  initials,
  onClick,
  className = "",
  imageUrl,
  avatarBackgroundColor,
}) => {
  return (
    <button className={`profile-button ${className}`} onClick={onClick}>
      <div className="profile-content">
        <div
          className="avatar"
          style={
            avatarBackgroundColor
              ? { backgroundColor: avatarBackgroundColor }
              : undefined
          }
        >
          {imageUrl ? (
            <img src={imageUrl} alt={initials} />
          ) : (
            <span>{initials}</span>
          )}
        </div>
        <span className="name">{name}</span>
      </div>
      <ChevronDown className="chevron" />
    </button>
  );
};
